import React, {useState, useEffect, useRef} from "react";
import {ClipboardCopy, Share2} from "lucide-react";
import {handleCopyUtils} from "../../../../utils/clipboardUtils";
import QRCodeModal from "../../../PaymentLogs/S2P/QRCodeComponent";
import {DownloadPDF} from "../../../../utils/generatorFiles/generatePDF";
import "./ShareMenu.css"
import {Tooltip} from "antd";

export default function ShareMenu({url, logsData, setCopied, pdfLogType}) {
    const [open, setOpen] = useState(false);
    const timerRef = useRef(null);

    const startAutoClose = () => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setOpen(false), 5000);
    };

    const stopAutoClose = () => {
        clearTimeout(timerRef.current);
    };

    useEffect(() => {
        if (open) startAutoClose();
        return () => clearTimeout(timerRef.current);
    }, [open]);

    return (
        <div className="share-menu-container">
            {/* Main share icon */}
            <Share2
                className="payment-log__action-buttons--inactive"
                style={{cursor: "pointer"}}
                onClick={() => setOpen(!open)}
            />

            {/* Mini share menu */}
            <div
                className={`share-menu ${open ? "open" : ""}`}
                onMouseEnter={stopAutoClose}   // keep open while hovering
                onMouseLeave={startAutoClose} // restart 5s timer when leaving
            >
                <Tooltip title="Copy Link to clipboard">
                    <ClipboardCopy
                        size={24}
                        style={{cursor: "pointer"}}
                        onClick={() => handleCopyUtils(url, setCopied)}
                    />
                </Tooltip>
                <QRCodeModal url={url}/>
                <DownloadPDF logsData={logsData} type={pdfLogType}/>
            </div>
        </div>
    );
}